import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { Post } from 'Xhr/Xhr';
import { env } from 'env';

export const SaveAppointment = async (data, navigate) => {
  console.log('-->', data);

  Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_SAVE_APPOINTMENT}`,
    true,
    {
      idPatient: data?.idPatient,
      idNobat: data?.idNobat,
    }
  ).then((response) => {
    // console.log('response is =>', response);
    if (response.data.resCode === 1) {
      sessionStorage.removeItem('saveTurn');
      localStorage.removeItem('pay_redirect');
      SwalAlert(
        'success',
        response.data.resMessage,
        false,
        null,
        null,
        null,
        false
      ).then(() => {
        if (navigate) {
          navigate('/main');
        } else {
          location.href = '/main';
        }
      });
    } else {
      SwalAlert('error', response.data.resMessage, false);
    }
    return response;
  });
};
